import { useLocation } from 'react-router';
import { BreadcrumbBuilder } from '@/components/common/Breadcrumb/BreadcrumbBuilder';
import { getBreadcrumbsForRoute } from '@/utils/routeBreadcrumbMapping';

// Breadcrumb component that renders the current breadcrumbs
const BreadcrumbRenderer = () => {
    const location = useLocation();
    const breadcrumbs = getBreadcrumbsForRoute(location.pathname);

    // Only show breadcrumbs if we have them (nested pages)
    if (!breadcrumbs || breadcrumbs.length <= 1) {
        return null;
    }

    return (
        <div className="mb-4">
            <BreadcrumbBuilder items={breadcrumbs} maxItems={5} showDropdown={true} className="text-sm" />
        </div>
    );
};

export default BreadcrumbRenderer;
